module.exports = __webpack_public_path__ + "img/avatar7.0134e7cd.png";